module.exports = __webpack_public_path__ + "media/img/vca/nomg5-8d6091452435640977bf3a1fc808339e.png";